<!--  -->
<template>
    <section class="input-section" :class="[inlineMessage ? 'flex al-ce ' : '']">
        <el-input v-on="$listeners" :placeholder="placeholder" v-bind="$attrs" class="custom-input" :class="[isError ? 'custom-input-error' : '']"
            @blur="validateFn"></el-input>
        <div class="is-error left " :class="[inlineMessage ? 'marginL5' : 'marginT5']" v-if="isError && !!validateMsg">
            {{ validateMsg }}</div>
    </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
        reg: {
            typeof: String,
            default: '',
        },
        validateMsg: {
            typeof: String,
            default: '',
        },
        inlineMessage: {
            typeof: Boolean,
            default: false,
        },
        placeholder: {
            typeof: String,
            default: '',
        }
    },
    data() {
        //这里存放数据
        return {
            isError: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //方法集合
    methods: {
        validateFn(e) {
            let value = e.currentTarget.value;
            this.isError = false;
            if (!!this.reg) {
                let reg = new RegExp(this.reg);
                if (!reg.test(value)) {
                    this.isError = true;
                }
            }
            this.$emit('blur')
        },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
$color189: #1890FF;
$colorF54: #F54A45;
$colorD3D: #D3D3D5;
$colorF0F: #F0F1F3;

.input-section {
    .custom-input {

        ::v-deep.el-input.is-disabled .el-input__inner:hover,
        ::v-deep.el-input.is-disabled .el-input__inner:focus,
        ::v-deep.el-input.is-disabled .el-input__inner {
            border-color: $colorD3D;
            background-color: $colorF0F;
        }

        ::v-deep.el-input .el-input__inner:hover,
        ::v-deep.el-input .el-input__inner:focus {
            border-color: $color189;
        }

        // ::v-deep.el-input .el-input__inner{
        //     height: 32px;
        //     line-height: 32px;
        // }
    }

    .custom-input-error {
        ::v-deep.el-input .el-input__inner {
            border-color: $colorF54;
        }
    }

    .is-error {
        color: $colorF54;
    }

    .left {
        text-align: left;
    }

    .marginT5 {
        margin-top: 5px;
    }

    .marginL5 {
        margin-left: 5px;
    }

}

.flex {
    display: flex;
}

.al-ce {
    align-items: center;
}
</style>